import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SuspendCardStackRoutes, SuspendCardStackScreenProps } from './type';
import { SuspendCardWebOneScreen } from './SuspendCardWebOne.screen';
import { SuspendCardNativeOneScreen } from './SuspendCardNativeOne.screen';

export interface SuspendCardProps {}
export const SuspendCardPlaced: React.FC<SuspendCardStackScreenProps<SuspendCardStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, account, tab, record, data, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <SuspendCardNativeOneScreen onClose={onGoBack} account={account} tab={tab} record={record} data={data} refresh={refresh} />;
  }

  return (
    <SuspendCardWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      data={data}
      refresh={refresh}
    />
  );
};
